(function ($) {
  $.fn.wsBlob = function (options) {
    if (typeof options != 'undefined' && options.constructor === String) {
      switch (options) {
        case 'resize':
          return this.each(function () {
            this.resizeBlob();
          });
        default:
          throw 'Option does not exist: ' + options;
      }
    }

    return this.each(function () {
      /*var opt = $.extend({
        delay: 100,
        speed: 10
      }, options);*/

      // Elements
      let blobElement;

      // Variables

      // Resize and make sure there's enough elements.
      let resizeBlob = this.resizeBlob = function () {
        let color = blobElement.data('ws-blob-color'); // HEX color
        let direction = blobElement.data('ws-blob-direction') || 'right'; // left, right, top, bottom.
        let type = blobElement.data('ws-blob-type') || 'full';
        let opacity = blobElement.data('ws-blob-opacity') || '1';

        let scaleMode = blobElement.data('ws-blob-scale-mode') || 'contain';

        let pWidth = blobElement.width();
        let pHeight = blobElement.height();

        let svgLength = 0;
        switch (type) {
          case 'half':
            svgLength = 70;
            break;
          case 'full':
          default:
            svgLength = 100;
            break;
        }

        // Letter defines the side the big part of the blob is on. So for example, R would have the small side on the left and the big side on the right.
        let paths = {
          'right': `
        M 84.768748,0 83.090473,0.09503695 9.0246893,5.1319953
        C 3.9581971,5.670538 0,9.8838427 0,14.984159
        c 0,5.100316 3.9581971,9.281942 9.0246893,9.852164
        L 83.058807,29.90496
        C 83.628787,29.968317 84.167102,30 84.737083,30 93.160126,30 99.99989,23.284056 99.99989,15.015841 100.03156,6.7159444 93.191792,0 84.768748,0
        Z
      `,
          'left': `
        m 15.23111,0 1.6783,0.095037 74.066,5.037
        c 5.0665,0.53854 9.0247,4.7518 9.0247,9.8522 0,5.1003 -3.9582,9.2819 -9.0247,9.8522
        l -74.034,5.0686
        c -0.56998,0.06336 -1.1083,0.09504 -1.6783,0.09504 -8.4230005,0 -15.26300046154,-6.7159 -15.26300046154,-14.984
        C -0.03156046,6.716177 6.8082095,7.7e-5 15.23111,7.7e-5
        Z
      `,
          'top': `
        m 30.00008,15.231109 -0.09504,1.6783 -5.037,74.066 c -0.53854,5.0665 -4.7518,9.024701 -9.8522,9.024701 -5.1002999,0 -9.2819,-3.958201 -9.8522,-9.024701 l -5.0686,-74.034 C 0.03168,16.371429 0,15.833109 0,15.263109 0,6.8401095 6.7159,1.0953846e-4 14.984,1.0953846e-4 23.2839,-0.03156046 30,6.8082095 30,15.231109 Z
      `,
          'bottom': `
        m 30.00008,84.769001 -0.09504,-1.6783 -5.037,-74.066 C 24.3295,3.958201 20.11624,0 15.01584,0 9.9155401,0 5.73394,3.958201 5.16364,9.024701 l -5.0686,74.034 C 0.03168,83.628681 0,84.167001 0,84.737001 0,93.160001 6.7159,100 14.984,100 23.2839,100.03167 30,93.191901 30,84.769001 Z
      `,
        };

        let svgPosition = [0, 0];
        let svgDimensions = [0, 0];
        let preserveAspectRatio = 'none';
        let path = '';
        switch (direction) {
          case 'left':
          case 'right':
            svgDimensions = [svgLength, 30];
            preserveAspectRatio = 'xMaxYMid slice';
            path = paths[direction];
            break;
          case 'top':
          case 'bottom':
            svgDimensions = [30, svgLength];
            preserveAspectRatio = 'xMidYMax slice';
            path = paths[direction];
            break;
        }

        switch (direction) {
          case 'left':
            svgPosition = [0, 0];
            break;
          case 'right':
            svgPosition = [-svgLength + 100, 0];
            break;
          case 'top':
            svgPosition = [0, 0];
            break;
          case 'bottom':
            svgPosition = [0, -svgLength + 100];
            break;
        }


        let elBlob = blobElement.children('svg.ws-blob');

        let svg = $(`
          <svg class="ws-blob" xmlns="http://www.w3.org/2000/svg" viewBox="${svgPosition[0]} ${svgPosition[1]} ${svgDimensions[0]} ${svgDimensions[1]}" preserveAspectRatio="${preserveAspectRatio}">
            <path
              style="
                fill: ${color};
                fill-opacity: ${opacity};
              "
              d="${path}"
            />
          </svg>
        `);
        if (elBlob.length === 0) {
          elBlob = svg;
          blobElement.prepend(elBlob);
        } else {
          elBlob.replaceWith(svg);
          elBlob = svg;
        }

        let width = pWidth;
        let height = pHeight;

        let left = 0;
        let top = 0;
        switch (direction) {
          case 'top':
          case 'bottom':
            width = (30 / svgLength) * height;
            left = pWidth / 2 - width / 2;
            break;
          case 'left':
          case 'right':
            height = (30 / svgLength) * width;
            top = pHeight / 2 - height / 2;
            break;
        }

        if (scaleMode !== 'contain') {
          if (width < pWidth) {
            width = pWidth;
            height = (svgLength / 30) * width;
            left = 0;
          }
          if (height < pHeight) {
            height = pHeight;
            width = (svgLength / 30) * height;
            top = 0;
          }

          switch (direction) {
            case 'top':
              top = 0;
              break;
            case 'bottom':
              top = pHeight - height;
              break;
            case 'left':
              left = 0;
              break;
            case 'right':
              left = pWidth - width;
              break;
          }
        }

        elBlob.css({
          'left': left + 'px',
          'top': top + 'px',
          'width': width + 'px',
          'height': height + 'px',
        });
      }



      let initialize = function (blobElementParameter) {
        blobElement = $(blobElementParameter);

        resizeBlob();
      };

      initialize(this);
      $(window).load(function () {
        resizeBlob();
      });

      $(window).resize(function () {
        resizeBlob();
      });

      let furthestScrollPosition = 0;

      $(window).bind('scroll', function() {
        let scrollPercent = ($(window).scrollTop() / ($(document).height() - $(window).height())) * 100;

        if (scrollPercent > furthestScrollPosition) {
          resizeBlob();
          furthestScrollPosition = scrollPercent;
        }
      });
    });
  };
})(jQuery);
